module.exports = __webpack_public_path__ + "img/recentprojects.df88baeb.png";